import {useMemo} from 'react'

import {PollQuestion} from 'src/api/cargo-c2c/types'

type UseQuestionArrangement = {
  alignItems: 'center' | 'stretch'
  direction: 'column' | 'row'
}

export const useQuestionArrangement = (question: PollQuestion): UseQuestionArrangement => {
  const {alignItems, direction} = useMemo<UseQuestionArrangement>(() => {
    const direction = question.answers_alignment === 'bottom' ? 'column' : 'row'

    return {
      alignItems: direction === 'row' ? 'center' : 'stretch',
      direction,
    }
  }, [question.answers_alignment])

  return {alignItems, direction}
}
